"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgAnnounce = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_ANNOUNCE", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M4 11.005v3.996a1 1 0 1 0 2 0v-3.235l8.34 3.172c.397.152.82.013.955-.39.294-.885.705-2.867.705-7.043s-.413-6.164-.708-7.052c-.135-.406-.56-.545-.96-.393L4 4.005h-.007l-2.752.206a1.094 1.094 0 0 0-.973.798C.185 5.305 0 6.125 0 7.505s.185 2.196.268 2.491c.132.469.54.761.97.795l2.753.214H4Zm9.696-8.56c.16 1.024.304 2.627.304 5.06 0 2.428-.144 4.027-.302 5.05L6 9.626V5.382l7.696-2.938ZM4 9l-1.92-.15C2.037 8.53 2 8.083 2 7.505c0-.579.038-1.028.08-1.35L4 6.01V9Z" }))); };
exports.default = SvgAnnounce;
